import React from 'react'
import moment from 'moment'
import DateTimePickerReactTz from '../../../_library/DateTimePickerReactTz'
// import { DISPLAY_FORMAT } from '../../../constants/timeFormats'

const FORMAT = 'YYYY-MM-DD HH:mm'

const EventSchedule = ({ onInputChange, values, errors, event, setErrors }) => {
  const minDate = moment().startOf('hours').add(1, 'hours').format(FORMAT)
  const minTime = moment().add(16, 'minutes').format()

  return (
    <div className="event-details-container">
      <h4>
        <img
          alt="nodata"
          src={asset('/resources/images/system_icons/events.svg')}
          style={{ width: 14, paddingBottom: 3, marginRight: 5 }}
        />
        Schedule Publishing
      </h4>
      <div className="row" style={{ width: '100%' }}>
        <div className="col-sm-6 col-12">
          <DateTimePickerReactTz
            id="scheduled_at"
            label="Schedule Date"
            placeholder="D MMM YYYY H:M AM"
            value={values.scheduled_at}
            error={errors.scheduled_at || ''}
            touched={true}
            onChange={dateValue => {
              if (moment(dateValue).tz(event.timezone).isSameOrBefore(moment().tz(event.timezone))) {
                onInputChange('scheduled_at', minTime)
              } else {
                onInputChange('scheduled_at', dateValue)
              }
            }}
            suggestion={''}
            disabled={false}
            minDate={minDate}
            minTime={minTime}
            hint={
              <span>
                <span>Select a date to publish the event.</span>
                <br />
                <span>The timing is based on the event timezone +15 minutes.</span>
              </span>
            }
          />
        </div>
      </div>
    </div>
  )
}

export default EventSchedule
